var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeaderHoverBot = function SvgIconHeaderHoverBot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DA613A",
    clipPath: "url(#icon-header-hover-bot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.645v2a1 1 0 0 0 1 1h.333v-4H1a1 1 0 0 0-1 1M19 9.645h-.333v4H19a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1M11.667 1.978a1.67 1.67 0 0 1-1.334 1.633v1.7h-.666v-1.7a1.667 1.667 0 1 1 2-1.633M14 11.645a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 11.645a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.978H4a2 2 0 0 0-2 2v7.333a2 2 0 0 0 1.993 2 .336.336 0 0 1 .34.334v1.71a.333.333 0 0 0 .519.278l3.315-2.21a.67.67 0 0 1 .368-.112H16a2 2 0 0 0 2-2V7.978a2 2 0 0 0-2-2M6 12.311a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333m5.95 1.177c-.022.034-.532.823-1.95.823s-1.928-.79-1.95-.823a.333.333 0 0 1 .563-.357c.02.028.369.514 1.387.514 1.027 0 1.373-.494 1.387-.515a.336.336 0 0 1 .46-.096c.152.098.198.3.102.454M14 12.311a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-header-hover-bot_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconHeaderHoverBot;